
jQuery(document).ready(function ($) {

  $('#js-announcement-bar-slider').slick({
    autoplay: true,
    arrows: false,
    dots: false,
    slidesToShow: 1,
    centerPadding: "10px",

    infinite: true,
    pauseOnHover: true,


    speed: 10000,
    autoplaySpeed: 2000,

    cssEase: 'linear'
  });


  /* Homepage collections slider for responsive view */

  if ($(window).width() < 1200) {
    $('#js-collections-slick-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow: $(".am-slick-slider__next"),
      nextArrow: $(".am-slick-slider__prev"),
      cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
      speed: 1000,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  /* Homepage collections slider for responsive view */
  $('.js-am-homepage-banner-slider').slick({
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: true,
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
    speed: 1000,
    autoplaySpeed: 2000,
    useTransform: false
  });

  // PDP Add to cart and varient picker html element removed to avoid code conflict

  if ($(window).width() < 750) {
    $('.am-variant-picker--desktop').remove();
    $('.product__info-wrapper .am-addtocartbtn').remove();
  }
  if ($(window).width() > 750) {
    $('.am-product-varient__drawer--mobile').remove();
    $('.am-product-buybutton--mobile').remove();
  }

  $('.slider-container').slick({
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: true,
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
    speed: 1000,
    autoplaySpeed: 2000,
    useTransform: false
  });

});

/* Announcement-bar */
$(window).on('resize', _.debounce(function () {
  $('#js-collections-slick-slider')[0].slick.refresh();
}, 100));